import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Search, ClipboardList, Crosshair, ShieldCheck } from "lucide-react";
const processSteps = [{
  num: "1",
  title: "Local Inspection",
  desc: "We conduct a thorough assessment of your Port Charlotte property, identifying vulnerabilities specific to our humid Southwest Florida climate.",
  icon: Search
}, {
  num: "2",
  title: "Custom Strategy",
  desc: "Based on our findings, we develop a targeted treatment plan designed to eliminate local threats, from subterranean termites to seasonal mosquitoes.",
  icon: ClipboardList
}, {
  num: "3",
  title: "Precision Action",
  desc: "Our licensed technicians apply highly effective, family-conscious treatments to eradicate pests at their source with minimal disruption.",
  icon: Crosshair
}, {
  num: "4",
  title: "Ongoing Defense",
  desc: "We establish a continuous monitoring and maintenance barrier to ensure your home remains a pest-free sanctuary year-round.",
  icon: ShieldCheck
}];
export default function PortCharlottePestProcess() {
  return <section id="portcharlottepestprocess" className="bg-background py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-foreground rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-foreground rounded-full blur-3xl translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl text-foreground mb-6 uppercase tracking-wide leading-tight">
            Our Port Charlotte <br className="hidden md:block" />
            <span className="text-foreground border-b-4 border-foreground pb-2">Pest Process</span>
          </h2>
          <p className="font-serif text-xl text-foreground/90 leading-relaxed mt-8">
            A proven, four-step approach designed specifically to combat the unique pest challenges of Charlotte County.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {processSteps.map((step, i) => {
          const Icon = step.icon;
          return <Card key={i} data-index={i} className="rounded-none border-4 border-foreground bg-card shadow-[8px_8px_0px_0px_hsl(240_3%_9%)] relative transition-transform hover:-translate-y-2 hover:shadow-[12px_12px_0px_0px_hsl(240_3%_9%)] duration-300">
                <div className="absolute top-0 right-0 bg-foreground text-background w-14 h-14 flex items-center justify-center font-default text-3xl border-b-4 border-l-4 border-foreground">
                  {step.num}
                </div>
                
                <CardHeader className="pt-12 pb-4">
                  <div className="w-12 h-12 bg-background border-2 border-foreground flex items-center justify-center mb-6 rounded-none shadow-[4px_4px_0px_0px_hsl(240_3%_9%)]">
                    <Icon className="w-6 h-6 text-foreground" />
                  </div>
                  <CardTitle className="font-default text-2xl text-card-foreground uppercase tracking-wide">
                    {step.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent>
                  <p className="font-serif text-card-foreground/80 text-lg leading-relaxed">
                    {step.desc}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="mt-20 flex justify-center">
          <Button asChild size="lg" className="rounded-full text-lg md:text-xl px-10 py-8 uppercase font-default tracking-wider shadow-xl hover:scale-105 transition-all duration-300 border-4 border-transparent hover:border-background">
            <Link to="/ContactPage">
              Get Your Free Inspection
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}